var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showmenu
    ? _c(
        "div",
        { staticClass: "mainmenu-holder", class: { open: _vm.sideopen } },
        [
          _c("i", {
            staticClass: "openclose",
            on: {
              click: function($event) {
                _vm.sideopen = !_vm.sideopen
              }
            }
          }),
          _vm._v(" "),
          _c(
            "nav",
            { staticClass: "mainmenu", class: { open: _vm.sideopen } },
            [
              _vm.user && _vm.user.length
                ? _vm._l(_vm.routes, function(route, i) {
                    return _c(
                      "span",
                      { key: i },
                      [
                        route.name == "bounty.campaign.twittercampaign"
                          ? _c(
                              "router-link-i18n",
                              {
                                class: route.name.replace(/\./g, "_"),
                                attrs: {
                                  to: route,
                                  id: "BountyCampaignTwittercampaign"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.clicked(route)
                                  }
                                }
                              },
                              [
                                route.meta.icon
                                  ? _c("Icon", {
                                      attrs: { name: route.meta.icon }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                route.meta.title
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm._f("text")(route.meta.title))
                                      )
                                    ])
                                  : route.meta.trans
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("trans")(route.meta.trans)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "router-link-i18n",
                              {
                                class: route.name.replace(/\./g, "_"),
                                attrs: { to: route },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.clicked(route)
                                  }
                                }
                              },
                              [
                                route.meta.icon
                                  ? _c("Icon", {
                                      attrs: { name: route.meta.icon }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                route.meta.title
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm._f("text")(route.meta.title))
                                      )
                                    ])
                                  : route.meta.trans
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("trans")(route.meta.trans)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                              ],
                              1
                            ),
                        _vm._v(" "),
                        route.children.length
                          ? _c(
                              "nav",
                              _vm._l(route.children, function(sroute, j) {
                                return _c(
                                  "span",
                                  { key: j },
                                  [
                                    _c(
                                      "router-link-i18n",
                                      {
                                        attrs: { to: sroute },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.clicked(true)
                                          }
                                        }
                                      },
                                      [
                                        sroute.meta.icon
                                          ? _c("Icon", {
                                              attrs: { name: sroute.meta.icon }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        sroute.meta.title
                                          ? _c("span", [
                                              _vm._v(_vm._s(sroute.meta.title))
                                            ])
                                          : sroute.meta.trans
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("trans")(
                                                      sroute.meta.trans
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.back && _vm.back.name
                ? _c(
                    "router-link-i18n",
                    {
                      staticClass: "backlink",
                      attrs: { to: { name: _vm.back.name } },
                      nativeOn: {
                        click: function($event) {
                          _vm.clicked(true)
                        }
                      }
                    },
                    [
                      _c(
                        "i",
                        { staticClass: "btn" },
                        [_c("Icon", { attrs: { name: "arrow" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("trans")("buttons.back")))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-680a9791", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680a9791","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Mainmenu.vue
// module id = null
// module chunks = 